































































import Vue from "vue";
import { mapActions } from "vuex";
import { get } from "../../api";
import { ItemIssueConditionOptions } from "../../types";
import DesignerSearch from "../DesignerSearch.vue";
export default Vue.extend({
  components: {
    DesignerSearch
  },
  data(): { [key: string]: any } {
    return {
      dropdownOptions: ItemIssueConditionOptions
    };
  },
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    saveDisabled() {
      return this.data.designer.display_name === "" ||
        this.data.date === "" ||
        this.data.issue_condition.name === ""
        ? true
        : false;
    }
  },
  inject: ["modalDoneAction"],
  methods: {
    onDropdownOptionSelected(selected: { name: string; display_name: string }) {
      this.data.issue_condition = selected;
    },
    handleDesignerSelect(value: { name: any; display_name: string }) {
      this.data.designer = value;
    },
    customYearPredictor(
      customizedDate: Date,
      selectedDate: Date | null = null
    ) {
      if (
        selectedDate &&
        selectedDate.getFullYear()! == customizedDate.getFullYear()
      ) {
        return true;
      } else return false;
    },
    customDatePredictor(currentDateObject: Date) {
      //disable all dates before today not including today
      if (currentDateObject.getTime() < this.getYesterdayDate().getTime()) {
        return true;
      } else {
        return false;
      }
    },
    getYesterdayDate(): Date {
      //calulate yesterday's date object
      let todayDate = new Date();
      let yesterdayDay = todayDate.getDate() - 1;
      let yesterdayDate = todayDate.setDate(yesterdayDay);
      return todayDate;
    },
    setSelectedDate(date: Date) {
      this.data.date = date;
    }
  }
});
